// alterado - revisado

import React from 'react'

import { 
    TextField,
} from '@material-ui/core'

import { Autocomplete } from '@material-ui/lab'

import {
    STYLE
} from '../../business-const/Style/Style'

export const AutocompletePadrao = props => {

    const { label, list, name, handleChange, ...rest } = props

    return (
        <Autocomplete
            className="mt-2 mb-2 w-full bg-textField"
            size="medium"
            options={list}
            getOptionLabel={(option) =>
                option
            }
            getOptionSelected={(option, value) => {
                return option === value;
              }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    fullWidth
                    multiline={true}
                    InputProps={{
                        style: STYLE(false, props.disabled).styleTextField,
                          ...params.InputProps,
                    }}
                    InputLabelProps={{
                        style: props.value || props.value === 0 ? STYLE(false, props.disabled).styleLabelTextFieldWithValue : STYLE(false, props.disabled).styleLabelTextField
                    }}
                    FormHelperTextProps={{
                        style: STYLE(false, props.disabled).styleHelperText
                    }}
                />
            )}
            onChange={(event, newValue) => {
                handleChange({
                    target: {
                        name: name,
                        value: !newValue ? '' : newValue,
                    },
                })
            }}

            {...rest}
        />
    )
}

